import React, { useState } from 'react'
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'
import { useConfirmationDialog } from 'components/ConfirmationDialog'
import useCustomerLocation from '../hooks/useCustomerLocation'

function CustomerLocation({
  open,
  onClose,
  customerId,
  existingLocation,
  onSaveLocationSuccess,
  onRemoveLocationSuccess,
}) {
  const [locationId, setLocationId] = useState(existingLocation?.locationId ?? '')
  const { createConfirmationDialog } = useConfirmationDialog()

  const { saveLocation, removeLocation, isSaving, isRemoving } = useCustomerLocation({
    onSaveLocationSuccess: location => {
      onSaveLocationSuccess(location)
      onClose()
    },
    onRemoveLocationSuccess: () => {
      onRemoveLocationSuccess()
      onClose()
    },
  })

  const handleSave = () => {
    const trimmed = locationId.trim()
    if (!trimmed) {
      return
    }
    saveLocation({ locationId: trimmed, customerId, existingLocationId: existingLocation?.id })
  }

  const isPending = isSaving || isRemoving
  const isUnchanged = existingLocation && locationId.trim() === existingLocation.locationId

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{existingLocation ? 'Manage Location' : 'Set Location'}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          The primary FactSet location ID (CLIENT_MAIN_CRM_ID) for this customer.
          {existingLocation &&
            ' Warning — changing the location ID may break FactSet JIT provisioning.'}
        </Typography>
        <TextField
          label="Location ID"
          value={locationId}
          onChange={e => setLocationId(e.target.value)}
          size="small"
          fullWidth
          disabled={isPending}
          autoFocus
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        {existingLocation ? (
          <Button
            color="error"
            onClick={() =>
              createConfirmationDialog({
                title: 'Remove Location?',
                body: 'Are you sure you want to remove this location? The customer will no longer receive automatic FactSet updates.',
                confirmButtonText: 'Remove',
                onConfirm: () => removeLocation({ existingLocationId: existingLocation.id }),
              })
            }
            disabled={isPending}
          >
            Remove Location
          </Button>
        ) : (
          <Box />
        )}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="text" onClick={onClose} disabled={isPending}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={isPending || !locationId.trim() || isUnchanged}>
            Save
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default CustomerLocation
